module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day03_01_stay-1a30a0994b06a1b98b905d1819cd4dd6.jpg";